import { makeStyles, Theme, createStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    field: {
      margin: theme.spacing(1, 0),
    },
  })
);
